import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enServices from './locales/en/services.json';
import enTransactions from './locales/en/transactions.json';
import enWebhooks from './locales/en/webhooks.json';
import enIqServices from './locales/en/iq-services.json';
import enDashboard from './locales/en/dashboard.json';
import enErrors from './locales/en/errors.json';
import enHelp from './locales/en/help.json';
import enWebhookConfig from './locales/en/webhook-config.json';
import enSubscriptions from './locales/en/subscriptions.json';
import enMerchants from './locales/en/merchants.json';

import deCommon from './locales/de/common.json';
import deServices from './locales/de/services.json';
import deTransactions from './locales/de/transactions.json';
import deWebhooks from './locales/de/webhooks.json';
import deIqServices from './locales/de/iq-services.json';
import deDashboard from './locales/de/dashboard.json';
import deErrors from './locales/de/errors.json';
import deHelp from './locales/de/help.json';
import deWebhookConfig from './locales/de/webhook-config.json';
import deSubscriptions from './locales/de/subscriptions.json';
import deMerchants from './locales/de/merchants.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        services: enServices,
        transactions: enTransactions,
        webhooks: enWebhooks,
        'iq-services': enIqServices,
        dashboard: enDashboard,
        errors: enErrors,
        help: enHelp,
        'webhook-config': enWebhookConfig,
        subscriptions: enSubscriptions,
        merchants: enMerchants,
      },
      de: {
        common: deCommon,
        services: deServices,
        transactions: deTransactions,
        webhooks: deWebhooks,
        'iq-services': deIqServices,
        dashboard: deDashboard,
        errors: deErrors,
        help: deHelp,
        'webhook-config': deWebhookConfig,
        subscriptions: deSubscriptions,
        merchants: deMerchants,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
